var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 20h9","key":0}),React.createElement("path",{"d":"M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z","key":1})]);
}

Edit.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-edit-3"};

module.exports = Edit;

Edit.default = Edit;
